module.exports = __webpack_public_path__ + "img/IoTServe5_1.7060a728.png";